// Client-safe money / date formatting (lib/catalog.ts is server-only).

export function formatCentsClient(cents: number): string {
  return `$${(cents / 100).toFixed(cents % 100 === 0 ? 0 : 2)}`;
}

/** "Ships by November 12, 2026" from an ISO-ish date, or null when absent / unparseable. */
export function shipsByText(shipsBy: string | null | undefined): string | null {
  if (!shipsBy) return null;
  const d = new Date(shipsBy.replace(' ', 'T').replace(/\+00$/, 'Z'));
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
}

/** The pre-order sentence shown on the PDP, in the cart and at checkout confirmation. */
export function preorderLine(shipsBy: string | null | undefined): string {
  const t = shipsByText(shipsBy);
  return t ? `Pre-order: ships by ${t}.` : 'Pre-order: ships once it arrives.';
}
